<div class="reg-page">
  <div class="reg-backdrop" aria-hidden="true">
    <span class="blob blob-1"></span>
    <span class="blob blob-2"></span>
    <span class="blob blob-3"></span>

    <!-- Floating homeopathy globules + friendly icons -->
    <span class="globule g-1"></span>
    <span class="globule g-2"></span>
    <span class="globule g-3"></span>
    <span class="globule g-4"></span>
    <i class="float-ic ic-1 pi pi-heart-fill"></i>
    <i class="float-ic ic-2 pi pi-plus"></i>
    <i class="float-ic ic-3 pi pi-star-fill"></i>
  </div>

  <div class="reg-shell">
    <!-- Brand header -->
    <header class="reg-brand">
      <div class="brand-mark">
        <i class="pi pi-plus-circle"></i>
      </div>
      <div class="brand-text">
        <h1 class="brand-name">Dr. Subodh Bhade</h1>
        <p class="brand-sub">Homeopathy Clinic</p>
      </div>
    </header>

    <!-- Progress -->
    <div class="reg-steps" *ngIf="step === 'identify' || step === 'register'">
      <div class="step-dot" [class.active]="step === 'identify'" [class.done]="step === 'register'">
        <span *ngIf="step === 'register'" class="pi pi-check"></span>
        <span *ngIf="step === 'identify'">1</span>
      </div>
      <div class="step-line" [class.fill]="step === 'register'"></div>
      <div class="step-dot" [class.active]="step === 'register'">2</div>
    </div>

    <!-- Friendly doctor (welcome only) -->
    <div class="doc-hero" *ngIf="step === 'identify'" aria-hidden="true">
      <div class="doc-stage">
        <img class="doc-img" src="drsubodh.png" alt="Dr. Subodh Bhade waving hello" />
      </div>
      <div class="doc-bubble">
        <span>Hi! I’m here to help — let’s get you registered. 😊</span>
      </div>
    </div>

    <!-- ============ STEP 1: IDENTIFY ============ -->
    <section class="reg-card" *ngIf="step === 'identify'">
      <div class="card-head">
        <h2>Welcome 👋</h2>
        <p>Let’s start by checking if you’re already with us.</p>
      </div>

      <div class="field">
        <label for="id-name">Full name <span class="req">*</span></label>
        <div class="input-wrap" [class.has-error]="identifyNameError">
          <i class="pi pi-user"></i>
          <input
            id="id-name"
            type="text"
            autocomplete="name"
            placeholder="First and last name"
            [(ngModel)]="identify.full_name"
            (keyup.enter)="checkPatient()" />
        </div>
        <small class="field-error" *ngIf="identifyNameError">
          <i class="pi pi-exclamation-circle"></i>
          Please enter both your first and last name.
        </small>
      </div>

      <div class="field">
        <label for="id-phone">Mobile number <span class="req">*</span></label>
        <div class="input-wrap">
          <i class="pi pi-phone"></i>
          <input
            id="id-phone"
            type="tel"
            inputmode="numeric"
            autocomplete="tel"
            placeholder="10-digit mobile number"
            [(ngModel)]="identify.contact_number"
            (ngModelChange)="onPhoneInput('identify')"
            (keyup.enter)="checkPatient()" />
        </div>
        <small class="field-hint">We use this to find your existing record.</small>
      </div>

      <button
        type="button"
        class="btn-primary"
        [disabled]="!isIdentifyValid || checking"
        (click)="checkPatient()">
        <span *ngIf="!checking">Continue</span>
        <span *ngIf="checking" class="btn-loading">
          <i class="pi pi-spin pi-spinner"></i> Checking…
        </span>
      </button>

      <p class="privacy-note">
        <i class="pi pi-lock"></i>
        Your details are kept private and secure.
      </p>
    </section>

    <!-- ============ STEP 2: REGISTER ============ -->
    <section class="reg-card" *ngIf="step === 'register'">
      <div class="card-head">
        <h2>Your details</h2>
        <p>A few quick details to complete your registration.</p>
      </div>

      <!-- Salutation -->
      <div class="field">
        <label>Title <span class="optional">(optional)</span></label>
        <div class="chip-row">
          <button
            type="button"
            class="pill"
            *ngFor="let s of salutations"
            [class.selected]="form.salutation === s"
            (click)="selectSalutation(s)">
            {{ s }}
          </button>
        </div>
      </div>

      <!-- Name -->
      <div class="field">
        <label for="r-name">Full name <span class="req">*</span></label>
        <div class="input-wrap" [class.has-error]="registerNameError">
          <i class="pi pi-user"></i>
          <input
            id="r-name"
            type="text"
            placeholder="First and last name"
            [(ngModel)]="form.full_name" />
        </div>
        <small class="field-error" *ngIf="registerNameError">
          <i class="pi pi-exclamation-circle"></i>
          Please enter both your first and last name.
        </small>
      </div>

      <div class="field-row">
        <!-- Age -->
        <div class="field field--age">
          <label>Age <span class="req">*</span></label>
          <app-patient-age-fields
            [(years)]="form.age"
            [(months)]="form.age_months"
            [(days)]="form.age_days"
          ></app-patient-age-fields>
        </div>

        <!-- Phone -->
        <div class="field">
          <label for="r-phone">Mobile <span class="req">*</span></label>
          <div class="input-wrap">
            <i class="pi pi-phone"></i>
            <input
              id="r-phone"
              type="tel"
              inputmode="numeric"
              placeholder="Mobile number"
              [(ngModel)]="form.contact_number"
              (ngModelChange)="onPhoneInput('form')" />
          </div>
        </div>
      </div>

      <!-- Optional details (collapsible feel) -->
      <div class="optional-block">
        <p class="optional-title">More details <span class="optional">(optional)</span></p>

        <div class="field">
          <label for="r-email">Email</label>
          <div class="input-wrap">
            <i class="pi pi-envelope"></i>
            <input
              id="r-email"
              type="email"
              autocomplete="email"
              placeholder="you@example.com"
              [(ngModel)]="form.email" />
          </div>
        </div>

        <div class="field">
          <label for="r-address">Address</label>
          <div class="input-wrap">
            <i class="pi pi-home"></i>
            <input
              id="r-address"
              type="text"
              placeholder="House, street, area"
              [(ngModel)]="form.address" />
          </div>
        </div>

        <div class="field-row">
          <div class="field">
            <label for="r-city">City</label>
            <div class="input-wrap">
              <input id="r-city" type="text" placeholder="City" [(ngModel)]="form.city" />
            </div>
          </div>
          <div class="field">
            <label for="r-pincode">Pincode</label>
            <div class="input-wrap">
              <input
                id="r-pincode"
                type="text"
                inputmode="numeric"
                placeholder="Pincode"
                [(ngModel)]="form.pincode" />
            </div>
          </div>
        </div>
      </div>

      <!-- Honeypot: hidden from humans; bots that fill it are silently dropped. -->
      <div class="hp-field" aria-hidden="true">
        <label for="company">Company</label>
        <input
          id="company"
          type="text"
          tabindex="-1"
          autocomplete="off"
          [(ngModel)]="honeypot"
          name="company" />
      </div>

      <div class="action-row">
        <button type="button" class="btn-ghost" (click)="backToStart()">
          <i class="pi pi-arrow-left"></i> Back
        </button>
        <button
          type="button"
          class="btn-primary grow"
          [disabled]="!isRegisterValid || submitting"
          (click)="submitRegistration()">
          <span *ngIf="!submitting">Submit registration</span>
          <span *ngIf="submitting" class="btn-loading">
            <i class="pi pi-spin pi-spinner"></i> Submitting…
          </span>
        </button>
      </div>
    </section>

    <!-- ============ ALREADY REGISTERED ============ -->
    <section class="reg-card state-card" *ngIf="step === 'found'">
      <div class="state-icon info">
        <i class="pi pi-id-card"></i>
      </div>
      <h2>You’re already registered</h2>
      <p class="state-sub">Great news, {{ result?.full_name }} — we found your record.</p>

      <div class="result-box">
        <span class="result-label">Your patient number</span>
        <span class="result-value">{{ result?.patient_number }}</span>
      </div>

      <p class="state-help">Please show this number at the reception desk.</p>

      <button type="button" class="btn-ghost full" (click)="backToStart()">
        <i class="pi pi-refresh"></i> Register someone else
      </button>
    </section>

    <!-- ============ SUBMITTED (pending approval) ============ -->
    <section class="reg-card state-card" *ngIf="step === 'submitted'">
      <div class="confetti" aria-hidden="true">
        <span></span><span></span><span></span><span></span><span></span>
        <span></span><span></span><span></span><span></span><span></span>
      </div>
      <div class="state-icon success">
        <i class="pi pi-check"></i>
      </div>
      <h2>Details submitted!</h2>
      <p class="state-sub">Thank you. Your registration has been received.</p>

      <div class="info-panel">
        <i class="pi pi-info-circle"></i>
        <p>
          Please visit the <strong>reception desk</strong> to complete your
          registration. Our staff will confirm your details and assign your
          patient number.
        </p>
      </div>

      <button type="button" class="btn-ghost full" (click)="backToStart()">
        <i class="pi pi-refresh"></i> Register another patient
      </button>
    </section>

    <!-- ============ ALREADY SUBMITTED / PENDING ============ -->
    <section class="reg-card state-card" *ngIf="step === 'alreadyPending'">
      <div class="state-icon info">
        <i class="pi pi-clock"></i>
      </div>
      <h2>Already submitted</h2>
      <p class="state-sub">We’ve already got your details.</p>

      <div class="info-panel">
        <i class="pi pi-info-circle"></i>
        <p>
          Your registration is awaiting confirmation. Please visit the
          <strong>reception desk</strong> — there’s no need to submit again.
        </p>
      </div>

      <button type="button" class="btn-ghost full" (click)="backToStart()">
        <i class="pi pi-refresh"></i> Start over
      </button>
    </section>

    <footer class="reg-footer">
      <i class="pi pi-shield"></i>
      Powered by Dr. Subodh Bhade Clinic
    </footer>
  </div>
</div>
